module.exports = __webpack_public_path__ + "static/media/stm_logo.b6499c3b.svg";